import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelSlides: [],
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelSlides: (state) => state.modelSlides,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelSlides = Array.isArray(recordsData?.modelSlides) ? recordsData.modelSlides : [];
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([apiClient.caxAFFxPhysiolSymptomsSchema()]);
        const [schemaRes] = responses.map((res) => res?.data ?? {});

        if (!schemaRes.schemaFormItems) throw new Error('Estructura de schema inválida.');

        let schema = structuredClone(schemaRes);

        const modelFormItems = [{ modelForm: { group1: {}, group2: {} } }];

        let modelSlides = modelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        const isNewRecord = true;
        const recordsData = { modelSlides, isNewRecord };
        commit('SET_SCHEMA', schema);
        commit('SET_RECORDS', recordsData);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState, getters, dispatch }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxAFFxPhysiolSymptoms(clinicalHistories_id, institutions_profes_id);
        let recordsData = res?.data?.data ?? {};
        const dataModelFormItems = recordsData.modelSlides;

        if (Object.keys(getters.schema).length === 0) {
          await dispatch('fetchSchema');
        }
        const schema = JSON.parse(JSON.stringify(getters.schema));

        let modelSlides = dataModelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        if (recordsData.isNewRecord === true) {
          modelSlides.physiological_aspect_id =
            dataModelFormItems[0].modelForm.physiological_aspect_id;
        }

        recordsData.modelSlides = modelSlides;
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxAFFxPhysiolSymptoms(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const preparedModel = prepareModel(rootState, model);
        const id = preparedModel.modelSlides[0].modelForm.physiological_aspect_id;
        await apiClient.updateCAxAFFxPhysiolSymptoms(id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
